/**
 * The start screen's picture strip: as many cards across as the width takes, two on a phone, and bigger cards
 * on bigger screens (a newsroom wall at 2000 px gets six wide cards, not eleven thumbnails). Pure, so the
 * page measures and this decides.
 */
export const FEATURED_GAP = 8;
/** The card width the layout aims for at a strip width (the strip then shares the width out evenly). */
export const featuredMinWidth = (stripWidth: number): number => (stripWidth >= 1800 ? 300 : stripWidth >= 1400 ? 260 : stripWidth >= 1000 ? 220 : 160);

export interface FeaturedLayout {
  cols: number;
  /** The card's width in pixels. */
  cardW: number;
  /** How much larger than the 176 px card of a laptop the type and the padding get (1 .. 1.9). */
  scale: number;
}

export function featuredLayout(stripWidth: number): FeaturedLayout {
  const min = featuredMinWidth(stripWidth);
  const cols = stripWidth <= 480 ? 2 : Math.max(2, Math.min(12, Math.floor((stripWidth + FEATURED_GAP) / (min + FEATURED_GAP))));
  const cardW = Math.max(1, (stripWidth - (cols - 1) * FEATURED_GAP) / cols);
  // the type grows only on big screens; a phone's two cards keep the laptop size
  return { cols, cardW, scale: stripWidth >= 1000 ? Math.min(1.9, Math.max(1, cardW / 176)) : 1 };
}
